export const PICKUP_COLOR = '#BA68C8';

export const DELIVERY_COLOR = '#4A4A4A';
